var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "media_and_text", style: _vm.cssVars }, [
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        {
          staticClass: "media_and_text__inner",
          class: { flip_horizontally: _vm.flip_horizontally },
        },
        [
          _c(
            "div",
            {
              staticClass: "media_and_text__inner__text",
              class: { flip_horizontally: _vm.flip_horizontally },
            },
            [
              _c("div", { staticClass: "inner" }, [
                _c("div", { staticClass: "content_container" }, [
                  _vm.subtitle
                    ? _c("h6", {
                        domProps: { innerHTML: _vm._s(_vm.subtitle) },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.title
                    ? _c("h2", { domProps: { innerHTML: _vm._s(_vm.title) } })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.text
                    ? _c("div", {
                        staticClass: "body",
                        domProps: { innerHTML: _vm._s(_vm.text) },
                      })
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "cta_container" },
                  [
                    (_vm.parsedImageOrVideo === "image" &&
                      _vm.parsedPrimaryButton) ||
                    (_vm.data_source != "module" &&
                      _vm.parsedImageOrVideo != "video" &&
                      _vm.parsedPrimaryButton)
                      ? _c("primary-button", {
                          attrs: {
                            link: _vm.parsedPrimaryButton.url
                              ? _vm.parsedPrimaryButton
                              : false,
                            label: _vm.parsedPrimaryButton.title
                              ? _vm.parsedPrimaryButton.title
                              : null,
                            theme:
                              this.text_colour === "#fff" ||
                              this.background_colour === "#211752" ||
                              this.background_colour === "#4f58f5"
                                ? "reverse"
                                : "normal",
                          },
                        })
                      : _vm.parsedImageOrVideo === "video"
                      ? _c("video-button", {
                          attrs: {
                            label: "Play Video",
                            video_source: _vm.parsedVideo,
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.parsedSecondaryButton
                      ? _c("secondary-button", {
                          attrs: {
                            link: _vm.parsedSecondaryButton,
                            label:
                              _vm.data_source === "module"
                                ? _vm.parsedSecondaryButton.title
                                : "Full Story",
                            theme:
                              this.text_colour === "#fff" ||
                              this.background_colour === "#211752" ||
                              this.background_colour === "#4f58f5"
                                ? "reverse"
                                : "normal",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.parsedImageOrVideo === "video"
            ? [
                _vm.parsedVideoPoster
                  ? _c(
                      "div",
                      {
                        staticClass: "media_and_text__inner__image",
                        class: { flip_horizontally: _vm.flip_horizontally },
                      },
                      [
                        _c("img", {
                          class: { flip_horizontally: _vm.flip_horizontally },
                          attrs: {
                            src: _vm.parsedVideoPoster.url
                              ? _vm.parsedVideoPoster.url
                              : _vm.parsedVideoPoster,
                            alt: _vm.title,
                          },
                        }),
                      ]
                    )
                  : _vm._e(),
              ]
            : [
                _vm.parsedImage
                  ? _c(
                      "div",
                      {
                        staticClass: "media_and_text__inner__image",
                        class: { flip_horizontally: _vm.flip_horizontally },
                      },
                      [
                        _c("img", {
                          class: { flip_horizontally: _vm.flip_horizontally },
                          attrs: {
                            src: _vm.parsedImage.url
                              ? _vm.parsedImage.url
                              : _vm.parsedImage,
                            alt: _vm.title,
                          },
                        }),
                      ]
                    )
                  : _vm._e(),
              ],
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }